import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal } from '../components'
import { history, IF } from '../helpers'
import { popupError, popupSuccess } from '../layout/img/image'
import { modalAlertaInfo, PosCheckOutXD } from '../layout/redux/layoutActions'

export default ({}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { alerta, sistema } = useSelector(state => state.layoutState)

  const [gtm, setGtm] = useState(null) // 🔹 guarda o objeto GTM retornado da API

  // Carrega tradução de forma segura
  let nlsPopup = { checkoutsucesso: {} }
  try {
    nlsPopup = require(`../layout/nlsPopup/${sistema?.idioma}.json`)
  } catch (err) {
    console.error('Erro ao carregar nlsPopup:', err)
  }

  // 🔹 Chama a API e guarda o retorno GTM
  useEffect(() => {
    const query = new URLSearchParams(location.search)
    const searchTerm = query.get('session_id')

    if (searchTerm) {
      dispatch(PosCheckOutXD(searchTerm)).then(res => {
        if (res) {
          setGtm(res) // 🔹 guarda o objeto GTM real
        } else {
          console.warn('⚠️ Nenhum objeto GTM recebido')
        }
      })
    }
  }, [location.search])

  // 🔹 Envia o objeto GTM real ao dataLayer (igual ao que fazia antes com objeto fixo)
  useEffect(() => {
    if (!gtm) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(gtm)
    console.log('🔥 Evento REAL enviado ao GTM:', gtm)
  }, [gtm])

  // 🔹 Exibe modal com sucesso da assinatura
  useEffect(() => {
    dispatch(modalAlertaInfo({
      ...nlsPopup.checkoutsucesso,
      show: false,
      btnAction: () => history.push('/minhasassinaruras'),
      textos: {}
    }))
  }, [])

  const textoCustom = (e, l) => {
    let texto = e
    if (l) {
      Object.keys(l).forEach(c => {
        texto = texto.replace(`{{${c}}}`, l[c])
      })
    }
    return texto
  }

  const imgCustom = e => {
    switch (e?.type) {
      case 'error':
        return popupError()
      default:
        return popupSuccess()
    }
  }

  return (
    <div className='page-alert box-content'>
      {alerta?.type && <div className='modal-modalAlerta-img'>{imgCustom(alerta)}</div>}
      {alerta?.titulo && <strong>{alerta.titulo}</strong>}
      {alerta?.texto && <p>{textoCustom(alerta.texto, alerta.textos)}</p>}
      <IF se={alerta?.btn && alerta?.btnAction}>
        <div className='modalAlerta-btns'>
          <Button
            type='btn block'
            color='primary'
            onClick={alerta.btnAction}
          >
            {alerta.btn}
          </Button>
        </div>
      </IF>
    </div>
  )
}
